import { Component, ElementRef, Inject, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { Constant } from 'src/app/constant/constant';
import { getPageSize } from '../utils/calsoft-validators';
import { CrmSearchService } from 'src/app/services/crm-search.service';
import { UsersService } from 'src/app/services/users.service';
import { UntypedFormControl } from '@angular/forms';

import { LeadActivityService } from 'src/app/services/lead-activity.service';
import { GoogleCalendarServiceAccountService } from 'src/app/services/google-calendar-service-account.service';

@Component({
  selector: 'calsoft-crm-search',
  templateUrl: './crm-search.component.html',
  styleUrls: ['./crm-search.component.scss']
})
export class CrmSearchComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';


  url = '';


  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  paginationDetail = new BehaviorSubject(
    {
      length: 10,
      pageIndex: 0,
      pageSize: 10
    });

  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;

  elements: any;
  pageList: any;

  sortParam: any = 'updatedDate' + "," + Constant.Dsc;
  sortParam1: any = 'a.start_datetime' + "," + Constant.Dsc;
  leadPageEnable: boolean = false;
  companyPageEnable: boolean = false;
  dealsPageEnable: boolean = false;
  leadActivityPageEnable: boolean = false;
  googleCalendarPageEnable: boolean = false;
  filterApplied: boolean;
  searchLead: string;
  searchForCompany: string;
  searchForDeals: string;
  searchForActivity: string;
  searchForMeeting: string;
  selectedOwnerConditionOnly: boolean;

  @ViewChild('searchInput') searchInput!: ElementRef;


  constructor(
    public dialogRef: MatDialogRef<CrmSearchComponent>,
    @Inject(MAT_DIALOG_DATA) public PopupadataLeadEntity: any,
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
    private crmSearchService: CrmSearchService,
    private usersService: UsersService,
    private leadActivityService: LeadActivityService,
    private googleCalendarServiceAccountService: GoogleCalendarServiceAccountService,

  ) {
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; }); }

  searchText: string = '';


  ngOnInit() {


    this.url=this.router.url;

    this.getUserDropDownList();
    this.usertypeYFilter();

  }

  ngAfterViewInit() {
  setTimeout(() => {
    this.searchInput.nativeElement.focus();
  }, 150);
}


  searchList: any = [
    { "label": "All results", "viewValue": "All results" },
    { "label": "lead", "viewValue": "lead" },
    { "label": "accounts", "viewValue": "accounts" },
    { "label": "deals", "viewValue": "deals" },
    { "label": "Tasks", "viewValue": "Tasks" },
    { "label": "Meetings", "viewValue": "Meetings" },
    // { "label": "Chats", "viewValue": "Chats" },
  ]


  placeHolderName: any = "CRM";

  selectedTab: any = 'All Results';

  onTabChange(event: MatTabChangeEvent) {

    console.log("event", event);

    if (event.tab.textLabel === "All Results") {

      this.placeHolderName = "CRM"
    } else {
      this.placeHolderName = event.tab.textLabel;
    }

    this.selectedTab = event.tab.textLabel;

  }

  spinner: boolean;
  searchLeadList: any;
  filterActive: boolean = false;
  search: any;
  pageSizeValue: any = [];


  getLeadOwnerSearch() {
    this.searchLeadList = [];
    this.searchCompanyList = [];
    this.searchDealsList = [];
    this.googleCalendarList = [];
    this.leadActivityList = [];
    this.searchLeadList = null;
    this.searchCompanyList = null;
    this.searchDealsList = null;
    this.googleCalendarList = null;
    this.leadActivityList = null;
    this.spinner = false;
  }



  filterOption(event, type: any) {

    let searchTerm = ""

    if (type == 1) {

      searchTerm =
        "name:" + "*" + event + "*" +
        " OR phoneNumber:" + "*" + event + "*" +
        " OR email:" + "*" + event + "*" +
        " OR company:" + "*" + event + "*";

    } else {
      searchTerm = event;
    }


    this.filterActive = true;
    this.searchLead = searchTerm;
    this.spinner = true;
    this.crmSearchService.getAllCrmLeadSearch(this.searchLead, this.page, this.size, this.sortParam).subscribe(
      res => {
        this.spinner = false;
        this.searchLeadList = res['content'];

        if (this.searchLeadList.length > 0) {
          this.leadPageEnable = true;
        }

        this.elements = res['numberOfElements'];
        this.pageList = res['totalElements'];
        this.pageSizeValue = getPageSize(this.pageList);
      },
      error => {
        this.spinner = false;
      })
  }

  searchCompanyList: any;

  filterOptionCompany(event, type: any) {

    let searchTerm = ""

    if (type == 1) {
      searchTerm =
        "name:" + "*" + event + "*" +
        " OR phoneNumber:" + "*" + event + "*" +
        " OR email:" + "*" + event + "*";

    } else {
      searchTerm = event;
    }

    this.filterActive = true;
    this.spinner = true;
    this.searchForCompany = searchTerm;
    this.crmSearchService.getAllCrmCompanySearch(this.searchForCompany, this.page, this.size, this.sortParam).subscribe(
      res => {
        this.spinner = false;
        this.searchCompanyList = res['content'];

        if (this.searchCompanyList.length > 0) {
          this.companyPageEnable = true;
        }

        this.elements = res['numberOfElements'];
        this.pageList = res['totalElements'];
        this.pageSizeValue = getPageSize(this.pageList);
      },
      error => {
        this.spinner = false;
      })
  }

  searchDealsList: any;


  filterOptionDeals(event, type: any) {

    let searchTerm = ""

    if (type == 1) {
      searchTerm =
        "leadName:" + "*" + event + "*" +
        " OR phoneNumber:" + "*" + event + "*" +
        " OR email:" + "*" + event + "*" +
        " OR company:" + "*" + event + "*";
    } else {
      searchTerm = event;
    }

    this.filterActive = true;
    this.searchForDeals = searchTerm;
    this.spinner = true;
    this.crmSearchService.getAllCrmDealsSearch(this.searchForDeals, this.page, this.size, this.sortParam).subscribe(
      res => {
        this.spinner = false;
        this.searchDealsList = res['content'];

        if (this.searchDealsList.length > 0) {
          this.dealsPageEnable = true;
        }

        this.elements = res['numberOfElements'];
        this.pageList = res['totalElements'];
        this.pageSizeValue = getPageSize(this.pageList);
      },
      error => {
        this.spinner = false;
      })
  }

  onSearch() {

    console.log(this.selectedSalesOwner);


    if (this.filterApplied) {

      this.applyFilters()

    } else {


      if (!this.searchText || this.searchText.trim() === '') {
        this.getLeadOwnerSearch();
        this.leadPageEnable = false;
        this.companyPageEnable = false;
        this.dealsPageEnable = false;
        this.leadActivityPageEnable = false;
        this.googleCalendarPageEnable = false;



      } else {
        this.page = Constant.PAGE;
        this.size = Constant.SIZE;

        let value = this.searchText.trim();

        this.filterOption(value, 1);
        this.filterOptionCompany(value, 1);
        this.filterOptionDeals(value, 1);
        this.filterOptionLeadActivity(value);
        this.filterOptionMeeting(value);
      }



    }


  }

  selectedSalesOwner: string = '';
  createdAtFilter: string = '';
  updatedAtFilter: string = '';

  clearFilters() {
    this.filterApplied = false;
    this.selectedSalesOwner = '';
    this.createdAtFilter = '';
    this.updatedAtFilter = '';
  }

  datePeriods = [
    { label: 'Last 7 days', value: 'last7' },
    { label: 'Last 30 days', value: 'last30' },
    { label: 'Last 90 days', value: 'last90' },
  ];

  applyFilters() {

    this.filterApplied = true;
    this.page = Constant.PAGE;
    this.size = Constant.SIZE;

    let conditions: string[] = [];

    let tab = (this.selectedTab || '').toLowerCase();

    let searchTermMeeting = '';
    let searchTask = '';
    if (this.searchText != null && this.searchText != '') {
      if (this.searchText && this.searchText.trim()) {

        let value = this.searchText.trim();


        if (tab === 'lead') {
          conditions.push(
            `(name:*${value}* OR phoneNumber:*${value}* OR email:*${value}* OR company:*${value}*)`
          );
        }

        else if (tab === 'accounts') {
          conditions.push(
            `(name:*${value}* OR phoneNumber:*${value}* OR email:*${value}*)`
          );
        }

        else if (tab === 'deals') {
          conditions.push(
            `(leadName:*${value}* OR phoneNumber:*${value}* OR email:*${value}* OR company:*${value}*)`
          );
        }

        else if (tab === 'all results') {


          searchTask = `a.subject:*${value}* AND a.ownerId:*${this.selectedSalesOwner},*`


          searchTermMeeting =
            `summary:*${value}* OR meeting_summary:*${value}*  OR meeting_summary:*${value}* AND owner_id:*${this.selectedSalesOwner},*`;

          conditions.push(
            `(name:*${value}* OR phoneNumber:*${value}* OR email:*${value}*)`
          );

        }
        else if (tab === 'Tasks') {
          searchTask = `a.subject:*${value}* AND a.ownerId:*${this.selectedSalesOwner},*`
        }
        else if (tab === 'Meetings') {
          searchTermMeeting =
            `summary:*${value}* OR meeting_summary:*${value}*  OR meeting_summary:*${value}* AND owner_id:*${this.selectedSalesOwner},*`;

        }
      }




      if (this.selectedSalesOwner != null && this.selectedSalesOwner != '') {

        if (this.selectedTab === 'deals') {

          if (this.selectedSalesOwner) {
            conditions.push(`dealsOwner:${this.selectedSalesOwner}`);
          }

        } else {

          if (this.selectedSalesOwner) {
            conditions.push(`ownerId:${this.selectedSalesOwner}`);
          }

        }

      }

      if (this.createdAtFilter && this.createdAtFilter != '') {
        conditions.push(`createdDate:${this.createdAtFilter}`);
      }

      if (this.updatedAtFilter && this.updatedAtFilter != '') {
        conditions.push(`updatedDate:${this.updatedAtFilter}`);
      }

      let searchTerm = conditions.join(" AND ");




      this.filterActive = true;
      this.search = searchTerm;
      this.spinner = true;

      if (tab === 'all results') {

        this.searchLead = searchTerm;
        this.searchForCompany = searchTerm;
        this.searchForMeeting = searchTermMeeting;

        this.searchForActivity = searchTask;
        this.filterOption(searchTerm, 2);
        this.filterOptionCompany(searchTerm, 2);
        this.searchMeeting(searchTermMeeting);
        this.searchActivity(searchTask);
        if (this.selectedSalesOwner) {

          let value = this.searchText.trim();
          let dealConditions: string[] = [];

          dealConditions.push(
            `email:*${value}*`
          );

          dealConditions.push(`dealsOwner:${this.selectedSalesOwner}`);

          let searchTermNew = dealConditions.join(" AND ");

          this.searchForDeals = searchTermNew;
          this.filterOptionDeals(searchTermNew, 2);
        }

      } else if (tab === 'lead') {
        this.searchLead = searchTerm;
        this.filterOption(searchTerm, 2);
      } else if (tab === 'accounts') {
        this.searchForCompany = searchTerm;
        this.filterOptionCompany(searchTerm, 2);
      } else if (tab === 'deals') {


        if (this.selectedSalesOwner) {

          let value = this.searchText.trim();
          let dealConditions: string[] = [];

          dealConditions.push(
            `email:*${value}*`
          );

          dealConditions.push(`dealsOwner:${this.selectedSalesOwner}`);

          let searchTermNew = dealConditions.join(" AND ");

          this.searchForDeals = searchTermNew;

          this.filterOptionDeals(searchTermNew, 2);
        }

      } else if (tab === 'Tasks') {
        this.searchForActivity = searchTask;
        this.searchActivity(searchTask);
      }
      else if (tab === 'Meetings') {
        this.searchForMeeting = searchTermMeeting;
        this.searchMeeting(searchTermMeeting);
      }



    } else {



      if (tab === 'lead') {
        conditions.push(
          `ownerId:*${this.selectedSalesOwner}*`
        );
      }

      else if (tab === 'accounts') {
        conditions.push(
          `ownerId:*${this.selectedSalesOwner}*`
        );
      }

      else if (tab === 'deals') {
        conditions.push(
          `ownerId:*${this.selectedSalesOwner}*)`
        );
      }

      else if (tab === 'all results') {


        searchTask = `a.ownerId:*${this.selectedSalesOwner},*`


        searchTermMeeting =
          `owner_id:*${this.selectedSalesOwner},*`;

        conditions.push(
          `ownerId:*${this.selectedSalesOwner}*`
        );

      }
      else if (tab === 'Tasks') {
        searchTask = `a.ownerId:*${this.selectedSalesOwner},*`
      }
      else if (tab === 'Meetings') {
        searchTermMeeting =
          `owner_id:*${this.selectedSalesOwner},*`;

      }




      if (this.selectedSalesOwner != null && this.selectedSalesOwner != '') {

        if (this.selectedTab === 'deals') {

          if (this.selectedSalesOwner) {
            conditions.push(`ownerId:${this.selectedSalesOwner}`);
          }

        } else {

          if (this.selectedSalesOwner) {
            conditions.push(`ownerId:${this.selectedSalesOwner}`);
          }

        }

      }

      if (this.createdAtFilter && this.createdAtFilter != '') {
        conditions.push(`createdDate:${this.createdAtFilter}`);
      }

      if (this.updatedAtFilter && this.updatedAtFilter != '') {
        conditions.push(`updatedDate:${this.updatedAtFilter}`);
      }

      let searchTerm = conditions.join(" AND ");




      this.filterActive = true;
      this.search = searchTerm;
      this.spinner = true;

      if (tab === 'all results') {
        this.searchLead = searchTerm;
        this.searchForCompany = searchTerm;
        this.searchForMeeting = searchTermMeeting;
        this.searchForActivity = searchTask;
        this.filterOption(searchTerm, 2);
        this.filterOptionCompany(searchTerm, 2);
        this.searchMeeting(searchTermMeeting);
        this.searchActivity(searchTask);
        if (this.selectedSalesOwner) {

          let value = this.searchText.trim();
          let dealConditions: string[] = [];


          dealConditions.push(`ownerId:${this.selectedSalesOwner}`);

          let searchTermNew = dealConditions.join(" AND ");

          this.searchForDeals = searchTermNew;
          this.filterOptionDeals(searchTermNew, 2);
        }

      } else if (tab === 'lead') {
        this.searchLead = searchTerm;
        this.filterOption(searchTerm, 2);
      } else if (tab === 'accounts') {
        this.searchForCompany = searchTerm;
        this.filterOptionCompany(searchTerm, 2);
      } else if (tab === 'deals') {


        if (this.selectedSalesOwner) {

          let value = this.selectedSalesOwner
          let dealConditions: string[] = [];
          dealConditions.push(`ownerId:${this.selectedSalesOwner}`);

          let searchTermNew = dealConditions.join(" AND ");
          this.searchForDeals = searchTermNew;
          this.filterOptionDeals(searchTermNew, 2);
        }

      } else if (tab === 'Tasks') {
        this.searchForActivity = searchTask;
        this.searchActivity(searchTask);
      }
      else if (tab === 'Meetings') {
        this.searchForMeeting = searchTermMeeting;
        this.searchMeeting(searchTermMeeting);
      }




    }


  }


  userTypeList: any;
  userList: any;
  filtereduserTypeList: any;
  public typeYFilterControl: UntypedFormControl = new UntypedFormControl();
  protected _onDestroy = new Subject<void>();

  getUserDropDownList() {

    let val: any = localStorage.getItem('userType')

    if (val == null) {
      val = 0;
    } else if (val == 'salesUser') {
      val = 1;
    } else {
      val = 0;
    }

    this.usersService.getAllUserStatusDropDownSales().subscribe(
      res => {
        this.userList = res;
        this.userTypeList = res;
        this.filtereduserTypeList = this.userTypeList;
      },
      error => {
      })

  }

  usertypeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.usertypeidYFilter();
      });
  }


  protected usertypeidYFilter() {
    if (!this.userTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereduserTypeList = this.userTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereduserTypeList = this.userTypeList.filter(user => user['email'].toLowerCase().indexOf(search) > -1)
  }

  getDaysAgo(dateString: string): string {
    const updatedDate = new Date(dateString);
    const today = new Date();

    // difference in milliseconds
    const diffMs = today.getTime() - updatedDate.getTime();

    // convert to days
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return 'updated today';
    if (diffDays === 1) return 'updated 1 day ago';
    return `updated ${diffDays} days ago`;
  }

  getAvatar(name: string): string {
    if (!name) return '';
    const parts = name.trim().split(' ');
    const initials = parts.map(p => p[0]).join('');
    return initials.substring(0, 2).toUpperCase();
  }

  onScroll(event: any, type: any) {
    const element = event.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      if (type == 1) {
        this.loadMore();
      } else if (type == 2) {
        this.loadMoreCompany();
      }
      else if (type == 3) {
        this.loadMoredeals();
      }
      else if (type == 4) {
        this.loadMoreActivity

      } else {
        this.loadMoreMeeting();
      }

    }
  }

  loadMore() {
    if (this.elements >= this.pageList) return;

    this.page++;
    this.spinner = true;

    this.crmSearchService.getAllCrmLeadSearch(this.searchLead, this.page, this.size, this.sortParam)
      .subscribe(res => {
        this.spinner = false;
        this.searchLeadList = [...this.searchLeadList, ...res['content']];
        this.elements += res['numberOfElements'];
      }, error => {
        this.spinner = false;
      });
  }


  loadMoreCompany() {
    if (this.elements >= this.pageList) return;

    this.page++;
    this.spinner = true;

    this.crmSearchService.getAllCrmCompanySearch(this.searchForCompany, this.page, this.size, this.sortParam)
      .subscribe(res => {
        this.spinner = false;
        this.searchCompanyList = [...this.searchCompanyList, ...res['content']];
        this.elements += res['numberOfElements'];
      }, error => {
        this.spinner = false;
      });
  }

  loadMoredeals() {
    if (this.elements >= this.pageList) return;

    this.page++;
    this.spinner = true;

    this.crmSearchService.getAllCrmDealsSearch(this.searchForDeals, this.page, this.size, this.sortParam)
      .subscribe(res => {
        this.spinner = false;
        this.searchDealsList = [...this.searchDealsList, ...res['content']];
        this.elements += res['numberOfElements'];
      }, error => {
        this.spinner = false;
      });
  }

  loadMoreActivity() {
    if (this.elements >= this.pageList) return;

    this.page++;
    this.spinner = true;

    this.leadActivityService.searchAllActivity(this.searchForActivity, this.page, this.size, this.sortParam, "")
      .subscribe(res => {
        this.spinner = false;
        this.leadActivityList = [...this.leadActivityList, ...res['content']];
        this.elements += res['numberOfElements'];
      }, error => {
        this.spinner = false;
      });
  }

  loadMoreMeeting() {
    if (this.elements >= this.pageList) return;

    this.page++;
    this.spinner = true;
    let additonalQuery = " a.start_datetime >= CURRENT_TIMESTAMP() AND a.end_datetime >= CURRENT_TIMESTAMP()";

    this.googleCalendarServiceAccountService.searchGoogleCalendar(null, this.page, this.size, this.sortParam1, additonalQuery)
      .subscribe(res => {
        this.spinner = false;
        this.googleCalendarList = [...this.googleCalendarList, ...res['content']];
        this.elements += res['numberOfElements'];
      }, error => {
        this.spinner = false;
      });
  }

  leadActivityList: any;

  filterOptionLeadActivity(event) {


    let searchTerm =
      "subject:" + "*" + event + "*";

    this.filterActive = true;
    this.search = searchTerm;
    this.spinner = true;

    this.searchForActivity = searchTerm;

    this.searchActivity(searchTerm)

  }

  searchActivity(search) {
    this.leadActivityService.searchAllActivity(search, this.page, this.size, this.sortParam, "").subscribe(
      res => {
        this.spinner = false;
        this.leadActivityList = res['content'];

        if (this.leadActivityList.length > 0) {
          this.leadActivityPageEnable = true;
        }

        this.elements = res['numberOfElements'];
        this.pageList = res['totalElements'];
        this.pageSizeValue = getPageSize(this.pageList);
      },
      error => {
        this.spinner = false;
      })
  }

  googleCalendarList: any;

  filterOptionMeeting(event) {

    let searchTerm =
      "a.summary:" + "*" + event + "*" +
      " OR a.meeting_summary:" + "*" + event + "*" +
      " OR a.description:" + "*" + event + "*";

    this.filterActive = true;
    this.spinner = true;

    this.searchForMeeting = searchTerm

    this.searchMeeting(this.searchForMeeting);

  }

  searchMeeting(search) {
    let additonalQuery = "null";
    this.googleCalendarServiceAccountService.searchGoogleCalendar(search, this.page, this.size, this.sortParam1, additonalQuery).subscribe(
      res => {
        this.spinner = false;
        this.googleCalendarList = res['content'];

        if (this.googleCalendarList.length > 0) {
          this.googleCalendarPageEnable = true;
        }

        this.elements = res['numberOfElements'];
        this.pageList = res['totalElements'];
        this.pageSizeValue = getPageSize(this.pageList);
      },
      error => {
        this.spinner = false;
      })

  }

  detailPage(entityId) {
    this.router.navigate([`leadDetail/${entityId}`])
    this.dialogRef.close();
  }

  companyDetailPage(entityId) {
    this.router.navigate([`companiesDetail/${entityId}`])
    this.dialogRef.close();
  }

  dealsDetailPage(entityId, setId) {
    this.router.navigate([`deals/add-edit-deals/${entityId}/${setId}`])
    this.dialogRef.close();
  }

  meetingDetailPage(id) {
    this.router.navigate([`/googleCalender/add-edit-google-calender/${id}`])
    this.dialogRef.close();
  }

  goToFirstResult() {
    // Navigate to the first available result based on current tab or priority
    const tab = (this.selectedTab || 'All results').toLowerCase();

    // If on specific tab, navigate to first result of that type
    if (tab === 'lead' && this.searchLeadList && this.searchLeadList.length > 0) {
      this.detailPage(this.searchLeadList[0].entityId);
    } else if (tab === 'accounts' && this.searchCompanyList && this.searchCompanyList.length > 0) {
      this.companyDetailPage(this.searchCompanyList[0].entityId);
    } else if (tab === 'deals' && this.searchDealsList && this.searchDealsList.length > 0) {
      this.dealsDetailPage(this.searchDealsList[0].entityId, this.searchDealsList[0].attributeSetId);
    } else if (tab === 'tasks' && this.leadActivityList && this.leadActivityList.length > 0) {
      // Tasks don't have a detail page, so we can show a message or skip
      console.log('Tasks detail page not implemented');
    } else if (tab === 'meetings' && this.googleCalendarList && this.googleCalendarList.length > 0) {
      this.meetingDetailPage(this.googleCalendarList[0].googleCalenderId);
    } else if (tab === 'all results') {
      // Navigate to first available result in priority order
      if (this.searchLeadList && this.searchLeadList.length > 0) {
        this.detailPage(this.searchLeadList[0].entityId);
      } else if (this.searchCompanyList && this.searchCompanyList.length > 0) {
        this.companyDetailPage(this.searchCompanyList[0].entityId);
      } else if (this.searchDealsList && this.searchDealsList.length > 0) {
        this.dealsDetailPage(this.searchDealsList[0].entityId, this.searchDealsList[0].attributeSetId);
      } else if (this.googleCalendarList && this.googleCalendarList.length > 0) {
        this.meetingDetailPage(this.googleCalendarList[0].googleCalenderId);
      } else if (this.leadActivityList && this.leadActivityList.length > 0) {
        console.log('Tasks detail page not implemented');
      }
    }
  }

  goToPage(pageType: string) {
    // Store search in localStorage using the existing pattern


    let targetUrl = '';
    let searchQuery = '';

    if (pageType == 'lead') {

      const url = '/lead';
      const cleanUrl = url;

      localStorage.removeItem(cleanUrl);


      let search = this.searchLead;

      const match = search.match(/\*(.*?)\*/);

      const extractedText = match ? match[1] : '';

      let object: any = {};

      this.selectedOwnerConditionOnly = false;

      if (this.selectedSalesOwner != extractedText) {

        object = {

          "name": extractedText,
          "phoneNumber": extractedText,
          "email": extractedText,
          "company": extractedText


        }
        this.selectedOwnerConditionOnly = false;

      } else {

        search = ''
        this.selectedOwnerConditionOnly = true;
      }



      if (this.selectedSalesOwner && this.selectedSalesOwner != '') {


        let indexForSelection = this.userList.findIndex(
          x => x.entityId == this.selectedSalesOwner
        );



        object['ownerEmail'] = this.userList[indexForSelection]?.email;

        if (this.selectedOwnerConditionOnly) {

          search = "ownerEmail:*" + this.userList[indexForSelection]?.email+",*";
        } else {
          search = search + " AND ownerEmail:*" + this.userList[indexForSelection]?.email+",*";
        }

      }


      localStorage.setItem(cleanUrl + 'select', JSON.stringify(object));
      localStorage.setItem(cleanUrl + 'type', '2');
      localStorage.setItem(cleanUrl + 'se', search);

      if (this.router.url === cleanUrl) {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([cleanUrl]);
        });
      } else {
        this.router.navigate([cleanUrl]);
      }

      this.dialogRef.close();

    } else if (pageType == 'accounts') {

      const url = '/companies';
      const cleanUrl = url;

      localStorage.removeItem(cleanUrl);

      let search = this.searchForCompany;

      const match = search.match(/\*(.*?)\*/);

      const extractedText = match ? match[1] : '';

      let object: any = {};

      this.selectedOwnerConditionOnly = false;

      if (this.selectedSalesOwner != extractedText) {

        object = {
          "name": extractedText,
          "phoneNumber": extractedText,
          "email": extractedText
        }
        this.selectedOwnerConditionOnly = false;

      } else {

        search = ''
        this.selectedOwnerConditionOnly = true;
      }

      if (this.selectedSalesOwner && this.selectedSalesOwner != '') {

        let indexForSelection = this.userList.findIndex(
          x => x.entityId == this.selectedSalesOwner
        );

        object['ownerEmail'] = this.userList[indexForSelection]?.email;

        if (this.selectedOwnerConditionOnly) {

          search = "ownerEmail:*" + this.userList[indexForSelection]?.email+",*";
        } else {
          search = search + " AND ownerEmail:*" + this.userList[indexForSelection]?.email+",*";
        }

      }

      localStorage.setItem(cleanUrl + 'select', JSON.stringify(object));
      localStorage.setItem(cleanUrl + 'se', search);
      localStorage.setItem(cleanUrl + 'type', '2');


      if (this.router.url === cleanUrl) {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([cleanUrl]);
        });
      } else {
        this.router.navigate([cleanUrl]);
      }

      this.dialogRef.close();

    } else if (pageType == 'deals') {

      const url = '/deals';
      const cleanUrl = url;

      localStorage.removeItem(cleanUrl);

      let search = this.searchForDeals;

      const match = search.match(/\*(.*?)\*/);

      const extractedText = match ? match[1] : '';

      let object: any = {};

      this.selectedOwnerConditionOnly = false;

      if (this.selectedSalesOwner != extractedText) {

        object = {
          "leadName": extractedText,
          "phoneNumber": extractedText,
          "email": extractedText,
          "company": extractedText
        }
        this.selectedOwnerConditionOnly = false;

      } else {

        search = ''
        this.selectedOwnerConditionOnly = true;
      }

      if (this.selectedSalesOwner && this.selectedSalesOwner != '') {

        let indexForSelection = this.userList.findIndex(
          x => x.entityId == this.selectedSalesOwner
        );

        object['dealsOwner'] = this.userList[indexForSelection]?.email;

        if (this.selectedOwnerConditionOnly) {

          search = "dealsOwner:*" + this.userList[indexForSelection]?.email+",*";
        } else {
          search = search + " AND dealsOwner:*" + this.userList[indexForSelection]?.email+",*";
        }

      }

      localStorage.setItem(cleanUrl + 'select', JSON.stringify(object));
      localStorage.setItem(cleanUrl + 'type', '2');
      localStorage.setItem(cleanUrl + 'se', search);

      if (this.router.url === cleanUrl) {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([cleanUrl]);
        });
      } else {
        this.router.navigate([cleanUrl]);
      }

      this.dialogRef.close();

    }

    else if (pageType == 'Tasks') {

      const url = '/leadActivityList';
      const cleanUrl = url;

      localStorage.removeItem(cleanUrl);

      let search = this.searchForActivity || '';

      const match = search.match(/\*(.*?)\*/);

      const extractedText = match ? match[1] : '';

      let object: any = {};

      this.selectedOwnerConditionOnly = false;

      if (this.selectedSalesOwner != extractedText) {

        object = {
          "label": extractedText,
          // "notes": extractedText,
          // "activityType": extractedText
        }
        this.selectedOwnerConditionOnly = false;

      } else {

        search = ''
        this.selectedOwnerConditionOnly = true;
      }


      if (this.selectedSalesOwner && this.selectedSalesOwner != '') {

        let indexForSelection = this.userList.findIndex(
          x => x.entityId == this.selectedSalesOwner
        );

        object['ownerEmail'] = this.userList[indexForSelection]?.email;
        object['ownerId'] = this.selectedSalesOwner;

        if (this.selectedOwnerConditionOnly) {

          search = "a.ownerId:*" + this.selectedSalesOwner + ",*";
        } else {
          search = search + " AND a.ownerId:*" + this.selectedSalesOwner + ",*";
        }

      }

      try { localStorage.setItem(cleanUrl + 'select', JSON.stringify(object)); } catch (e) {}
      localStorage.setItem(cleanUrl + 'type', '2');
      localStorage.setItem(cleanUrl + 'se', search);

      if (this.router.url === cleanUrl) {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([cleanUrl]);
        });
      } else {
        this.router.navigate([cleanUrl]);
      }

      this.dialogRef.close();

    } else if (pageType == 'Meetings') {

      const url = '/googleCalender';
      const cleanUrl = url;

      localStorage.removeItem(cleanUrl);

      let search = this.searchForMeeting || '';

      const match = search.match(/\*(.*?)\*/);

      const extractedText = match ? match[1] : '';

      let object: any = {};

      this.selectedOwnerConditionOnly = false;

      if (this.selectedSalesOwner != extractedText) {

        object = {
          "summary": extractedText,
          "description": extractedText
        }
        this.selectedOwnerConditionOnly = false;

      } else {

        search = ''
        this.selectedOwnerConditionOnly = true;
      }

      if (this.selectedSalesOwner && this.selectedSalesOwner != '') {

        let indexForSelection = this.userList.findIndex(
          x => x.entityId == this.selectedSalesOwner
        );

        object['ownerEmail'] = this.userList[indexForSelection]?.email;
        object['ownerId'] = this.selectedSalesOwner;

        if (this.selectedOwnerConditionOnly) {

          search = "owner_id:*" + this.selectedSalesOwner + ",*";
        } else {
          search = search + " AND owner_id:*" + this.selectedSalesOwner + ",*";
        }

      }

      try { localStorage.setItem(cleanUrl + 'select', JSON.stringify(object)); } catch (e) {}
      localStorage.setItem(cleanUrl + 'type', '2');
      localStorage.setItem(cleanUrl + 'se', search);

      if (this.router.url === cleanUrl) {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([cleanUrl]);
        });
      } else {
        this.router.navigate([cleanUrl]);
      }

      this.dialogRef.close();

    }

  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
